import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidemenuComponent } from './features/sidemenu/sidemenu.component';
import { HeaderComponent } from './features/header/header.component';
import { AuthService } from './auth/auth.service';
import { NgClass } from '@angular/common';
import { LoaderComponent } from './features/Common/loader/loader.component';
import { FeatureTabsComponent } from './shared/components/feature-tabs/feature-tabs.component';
import { PasswordPromptComponent } from './shared/components/password-prompt/password-prompt.component';
import { PageUsageService } from './core/services/page-usage.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidemenuComponent, HeaderComponent, NgClass, LoaderComponent, FeatureTabsComponent, PasswordPromptComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'pos-billing-app';
  authService = inject(AuthService);
  private pageUsage = inject(PageUsageService);

  constructor() {
    // Set the default theme to dark
    document.documentElement.setAttribute('data-theme', 'dark');
    // Counts screen views per workspace for Super Admin > Usage & Billing.
    this.pageUsage.start();
  }

  async ngOnInit() {
    // A focused number input steps its value on mouse-wheel, so scrolling a
    // long GRN/PO table silently changes quantities and prices. Blurring it on
    // wheel keeps the typed value and lets the scroll reach the page instead.
    document.addEventListener(
      'wheel',
      (event) => {
        const target = event.target as HTMLElement | null;
        if (target instanceof HTMLInputElement && target.type === 'number' && document.activeElement === target) {
          target.blur();
        }
      },
      { capture: true, passive: true },
    );

    // Add beforeunload event listener to warn users about unsaved changes
    window.addEventListener('beforeunload', (event) => {
      // Only show warning if user is logged in
      if (this.authService.isLoggedIn()) {
        // Prevent default behavior and show confirmation dialog
        event.preventDefault();
        // Chrome requires returnValue to be set
        event.returnValue = '';
        // Return message (modern browsers will show their own generic message)
        return 'Changes you made may not be saved. Are you sure you want to leave this page?';
      }
      return undefined;
    });
  }
}
